import PropTypes from 'prop-types'
import React, { useCallback, useEffect } from 'react'
import { useForm, FormProvider, useWatch } from 'react-hook-form'
import { useSelector, useDispatch } from 'react-redux'
import { Alert } from 'reactstrap'

import { PageLoader } from '../../generic'
import { showRegisterForm, showResetForm, login as loginUser } from '../store/actions'
import { getSubmitting } from '../store/selectors'

import Input from './generic/Input'
import useErrors from './generic/useErrors'

const inputFields = [{
  type: 'email',
  className: 'form-control qa-login-email',
  name: 'email',
  placeholder: 'E-Mail',
  required: true
}, {
  type: 'password',
  className: 'form-control qa-login-password',
  name: 'password',
  placeholder: 'Passwort',
  required: true
}]

const LoginForm = ({ updateFormData }) => {
  const methods = useForm()
  const dispatch = useDispatch()
  const isSubmitting = useSelector(getSubmitting)

  const { handleSubmit, setError, setFocus, control } = methods
  const { formSubmitMessages, resetErrors } = useErrors(setError)

  const emailValue = useWatch({
    control,
    name: 'email',
    defaultValue: ''
  })

  const onRegisterClick = useCallback((event) => {
    event.preventDefault()
    dispatch(showRegisterForm())
  }, [dispatch])

  const onResetClick = useCallback((event) => {
    event.preventDefault()
    updateFormData('email', emailValue)
    dispatch(showResetForm())
  }, [dispatch, emailValue, updateFormData])

  const onSubmit = useCallback((data) => {
    resetErrors()
    dispatch(loginUser(data))
  }, [dispatch, resetErrors])

  useEffect(() => {
    setFocus('email')
  }, [setFocus])

  return (
    <FormProvider {...methods}>
      <form
        className='form form-login qa-form-login'
        onSubmit={handleSubmit(onSubmit)}
      >
        {formSubmitMessages.length > 0 &&
          <div>
            <Alert className='qa-alert' color='danger'>{formSubmitMessages.toString()}</Alert>
          </div>}

        {inputFields.map(({ type, className, placeholder, name, required }) => (
          <div key={name} className='form-group'>
            <Input
              type={type}
              className={className}
              placeholder={placeholder}
              name={name}
              required={required}
            />
          </div>
        ))}
        <div className='d-flex flex-column flex-lg-row justify-content-between w-100'>
          <div className='form-group'>
            <div className='custom-control custom-checkbox'>
              <Input
                type='checkbox'
                id='remember_me'
                className='custom-control-input qa-login-remember'
                label='Angemeldet bleiben'
                name='remember_me'
                required={false}
              />
              <label className='custom-control-label' htmlFor='remember_me'>Angemeldet bleiben</label>
            </div>
          </div>
          <div className='form-group'>
            <a href='#' className='text-secondary qa-reset-pwd' onClick={onResetClick}>Passwort vergessen?</a>
          </div>
        </div>
        <div className='d-flex flex-column flex-lg-row justify-content-around w-100 mt-3'>
          {isSubmitting
            ? <PageLoader />
            : (
              <>
                <button
                  type='submit'
                  className='btn btn-primary qa-login-submit'
                >Anmelden
                </button>
                <a
                  role='button'
                  href='#'
                  className='btn btn-outline-primary qa-register-btn'
                  onClick={onRegisterClick}
                >
                  Registrieren
                </a>
              </>
              )}
        </div>
      </form>
    </FormProvider>
  )
}

LoginForm.propTypes = {
  requestErrors: PropTypes.shape({
    $messages: PropTypes.arrayOf(PropTypes.string)
  }),
  updateFormData: PropTypes.func
}

export default LoginForm
